import { useState } from "react";
import * as global from "@components";

/**
 * MapTemplate Component, is used for: [JMRV, LUCA, REDDAI]
 *
 * This component displays a web page section that shows:
 * - A header with meta information (like page title and description)
 * - A map embedded inside an iframe (like a window showing another website)
 *
 * While the map is loading, it shows a loading indicator (provided in the constants).
 *
 * Props:
 * - constants: An object containing configuration such as:
 *    - metaProps: Information for the page header (title, description, etc.)
 *    - loading: What to display while the map is loading (e.g. a spinner)
 *    - url: The web address of the map to display inside the iframe
 */
export default function MapTemplate({ constants }) {
    // loading state keeps track if the map iframe is still loading
    const [loading, setLoading] = useState(true);

    return (
        <>
            {/* HEADER */}
            {/* This renders the page metadata like title and description */}
            <global.MetaTagHeader {...constants.metaProps} />

            {/* MOBILE NOTICE */}
            <div className="flex items-center justify-center bg-yellow-50 px-4 py-2 text-center text-sm text-yellow-800 md:hidden">
                This map is best viewed on a desktop browser.
            </div>

            {/* MAIN MAP CONTAINER */}
            <div className="h-[100dvh] w-full mt-[60px] md:h-iframeScreen">
                {/* Show the loading indicator while the iframe content loads */}
                {loading && constants.loading}

                {/* 
                    iframe embeds another webpage (the map).
                    When it finishes loading, we update the loading state to hide the loading indicator.
                    The iframe is always full size; the loader overlays it while loading.
                */}
                <iframe
                    title="map"
                    src={constants.url}
                    className="h-full w-full"
                    onLoad={() => setLoading(false)}
                    allow="clipboard-write"
                    allowFullScreen
                />
            </div>
        </>
    );
}
